'use client';

import { format } from 'date-fns';

import { cn } from '@/lib/utils';

type TimelineItem = {
  icon: React.ReactNode;
  children: React.ReactNode;
  date: React.ReactNode;
};

export function Timeline({ items, className }: { items: TimelineItem[]; className?: string }) {
  return (
    <div className={cn('relative space-y-6', className)}>
      <ul className="relative">
        {items.map((item, idx) => (
          <li key={idx} className="relative flex items-start gap-4 pb-8">
            {idx < items.length - 1 && (
              <div className="bg-border absolute top-0 bottom-0 left-[15px] w-[2px]" />
            )}
            <div className="border-card relative z-10 -mt-[5px] flex items-center justify-center rounded-full border-[5px]">
              {item.icon}
            </div>
            <div className="flex flex-1 flex-col text-sm lg:flex-row-reverse lg:justify-between lg:gap-6">
              <time className="text-muted-foreground shrink-0 text-xs/5">{item.date}</time>
              <div>{item.children}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
